<template>
  <div class="target-container">
    <!-- 검색어 -->
    <lego-text-field
      ref="input"
      searchable
      v-model="productName"
      :placeholder="$t('searchLabel.searchLike', { VPC: $t('searchLabel.monTarget') })"
      counter="100"
      :isCounter="false"
      :disabled="disabled"
      disableInputMutation
      @click-icon="searchFields"
      @enter="searchFields"
    />

    <div class="logMessage">
      <!-- 모니터링 대상 -->
      <div class="target-list">
        <div class="monitoringTitle">
          {{ $util.capitalize($t('label.monitoring')) }} {{ $t('label.target') }}
        </div>
        <c-scroll v-show="searchedTargetList.length > 0" style="height: 450px">
          <div class="targetArea">
            <div
              class="target-item"
              v-for="(item, iIdx) in searchedTargetList"
              :key="iIdx"
              :class="{ selected: item.monKey === selectedTarget }"
              @click="onSelectTarget(item)"
              style="cursor: pointer"
            >
              <span class="text-field-ellipsis" v-lego-tooltip:ellipsis="`${item.productName}`">
                {{ item.productName }}
              </span>
            </div>
          </div>
        </c-scroll>
        <div style="width: 220px; height: 100%">
          <NullWidget v-show="searchedTargetList.length == 0" :errorMessage="errorMessage" />
        </div>
      </div>

      <!-- 로그목록 -->
      <lego-paging-table
        ref="monTarget"
        style="width: 100%"
        v-model="selectedLogs"
        :valueKey="['service.type', 'productResourceId']"
        multiSelect
        selectAll
        tableFixed
        isNotScrollX
        noPage
        :items="items"
        :headers="headers"
        :selectActionControl="false"
        :noSelectedShow="true"
        :isActionSelect="false"
        :noDataText="noDataText"
        @sort="onClickSort"
        :scrollMaxRow="13.5"
        :scrollFixRow="13.5"
        @update:modelValue="updateSelectedLog"
      ></lego-paging-table>
    </div>
  </div>
</template>
<script>
import _ from 'lodash';
import tableMixins from '@/mixins/table.mixin.js';
import i18nMixin from '@/mixins/i18n.mixin.js';
import NullWidget from '@/containers/widget/components/NullWidget';
import validateSearchMixin from '@/mixins/validateSearch.mixin';
import TooltipAndOther from '@/containers/components/TooltipAndOther';

export default {
  mixins: [tableMixins, i18nMixin, validateSearchMixin],
  props: ['params'],
  components: {
    NullWidget
  },
  data() {
    return {
      productName: '',
      searchedTargetList: [],
      targetList: [],
      selectedTarget: '',
      agentClassCode: '',
      selectedLogs: [],

      headers: [
        {
          text: this.$t('label.fileName'),
          value: 'service.type',
          width: 150,
          sortable: true,
          defaultValue: '-'
        },
        {
          text: this.$t('label.filePath'),
          value: 'log.file.path',
          sortable: true,
          customCell: {
            name: 'logFilePath',
            components: { TooltipAndOther },
            props: {
              value: {
                type: String,
                default: ''
              }
            },
            computed: {
              items() {
                return this.value?.split(',');
              }
            },
            template: `
              <TooltipAndOther  v-if='value' onlyShowAnd :items='items'/>`
          }
        }
      ],

      errorMessage: 'label.noData',
      authorization: true,
      disabled: false
    };
  },

  watch: {
    searchedTargetList: _.debounce(function (newVal, oldVal) {
      if (this.searchedTargetList.length > 0) {
        this.agentClassCode = this.searchedTargetList[0].agentClassCode;
        this.selectedTarget = this.searchedTargetList[0].monKey;
        if (this.params.selectedLog.length) this.selectedTarget = this.params.selectedLog[0].monKey;
        this.selectedLogs = this.$util.deepCopy(this.params.selectedLog);
      } else {
        this.agentClassCode = '';
        this.selectedTarget = '';
        this.items = [];
        this.selectedLogs = [];
      }
    }, 300),

    params: {
      handler() {
        this._getTargets();
      },
      immediate: true,
      deep: true
    },
    selectedTarget() {
      this.handleCheckAuthorization();
    }
  },
  computed: {},
  mounted() {
    // this.$refs['modal'].open();
    // this._pageInit();
  },
  methods: {
    // 초기화면 세팅
    async _pageInit() {
      // 모니터링 대상 조회
      await this._getTargets();
    },

    // 모니터링 대상 조회
    _getTargets(productName = '') {
      this.targetList = [];
      let param = {
        productName: encodeURIComponent(productName),
        popupChk: 'Y',
        size: 1000
      };

      this.$http.product
        .getTargetProductList(param, this.params.productTypeCode, true)
        .then((res) => {
          this.errorMessage = 'label.noData';
          if (res.contents) {
            this.targetList = res.contents;
            this.searchedTargetList = this.targetList;
          }
        })
        .catch((error) => {
          if (error && error.code == 'AccessDenied') {
            this.$alert(error, () => {
              this.setAccessDeniedMessage(
                `${
                  'message.accessError' + error.params.find((item) => item.name == 'action').value
                }`
              );
              this.errorMessage = `${
                'message.accessError' + error.params.find((item) => item.name == 'action').value
              }`;
            });
          }
        });
    },

    // 모니터링 대상 선택
    onSelectTarget(item) {
      if (this.selectedTarget !== item.monKey) {
        if (this.$refs.monTarget) this.$refs.monTarget.$refs.table.resetSort();
        this.selectedTarget = item.monKey;
        this.agentClassCode = item.agentClassCode;
      }
    },

    async handleCheckAuthorization() {
      if (this.selectedTarget) {
        const target = this.searchedTargetList.find((item) => item.monKey === this.selectedTarget);
        const param = {
          productTypeCode: this.params.productTypeCode,
          actionName: this.$const.AuthorizationAction.MONITOR_VIEW,
          productResourceIds: [target.productResourceId],
          listDataCheckAuth: [
            { productResourceId: target.productResourceId, productName: target.productName }
          ]
        };
        this.disabled = true;

        await this.$store.dispatch('authStore/checkProductResource', param).then((data) => {
          if (data && data.type === this.$const.AuthorizationResult.ALLOW) {
            this.getData();
            this.authorization = true;
          } else {
            this.items = [];
            this.authorization = false;
          }
        });

        this.disabled = false;
        this.$nextTick(() => {
          const inputField = this.$refs?.input?.$refs?.input;
          if (!inputField) return;
          inputField.focus();
          inputField.setSelectionRange(this.productName.length, this.productName.length);
        });
      }
    },

    // 로그 목록 조회
    getData() {
      if (!this.selectedTarget) {
        this.items = [];
        return;
      }
      let searchParam = {
        monKey: this.selectedTarget,
        sort: ['@timestamp:desc'],
        size: 0,
        page: 0
      };
      const { param } = this.getSearchParamWithTrim(searchParam);
      this.$http.log
        .getLogs(param, this.params.productTypeCode, true)
        .then((res) => {
          if (res.contents) {
            let productInfo = this.targetList.find((item) => item.monKey === this.selectedTarget);
            this.items = res.contents.map((item) => {
              item = this.$util.deepCopy({ ...item, ...productInfo });
              return item;
            });
          }
        })
        .catch((error) => {
          if (error && error.code == 'AccessDenied') {
            this.$alert(error, () => {
              this.setAccessDeniedMessage(
                `${
                  'message.accessError' + error.params.find((item) => item.name == 'action').value
                }`
              );
            });
          } else {
            this.items = [];
          }
        });
    },

    // 선택 로그 삭제
    onDelete(type, item, idx) {
      this.selectedLogs.splice(idx, 0);
    },

    // 검색어 체크
    mutateProductName(value) {
      return value.replace(this.$const.NOT_ALLOWED_REGEX.MORNITORING_NAME, '');
    },

    // 취소/닫기
    close() {
      this.$emit('close');
    },
    onClickSort(sortItem) {
      this.sort.sortOrder = sortItem.asc ? 'asc' : 'desc';
      if (this.authorization) {
        this.sort.sortDataField = sortItem.value;
        this.page.currentPage = 1;
        this.page.currentIndex = 0;
        this.getData(this.currentSearchParam);
      }
    },
    searchFields() {
      const conditionType = this.params.productTypeCode;
      // this.execSearchForRules('target', this.productName, conditionType);
      this.execSearch();
      this.$refs.input.blur();
    },
    resetSearchField() {
      this.productName = '';
      this.execSearch();
      //
    },
    execSearch() {
      if (this.productName) {
        this.searchedTargetList = this.targetList.filter(
          (item) => -1 < item.productName.toLowerCase().indexOf(this.productName.toLowerCase())
        );
      } else {
        this.searchedTargetList = this.targetList;
      }
    },
    updateSelectedLog() {
      this.$emit('selected-items', this.selectedLogs);
    }
  }
};
</script>
<style lang="scss" scoped>
.target-container {
  height: 100%;
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 16px;
}

.listTargetItem {
  color: #364fc7;
}

.logMessage {
  display: flex;
  gap: 24px;
  height: 100%;
  width: 100%;

  .target-list {
    height: 100%;
  }

  & > :first-child {
    width: 220px;
    min-width: 220px;
    height: 100%;
    display: flex;
    flex-direction: column;
    border-right: 1px solid #e3e5e8;
  }

  .monitoringTitle {
    padding: 8px 0;
    color: #2e3138;
    font-family: $lego__font-family;
    font-size: 15px;
    font-style: normal;
    font-weight: 500;
    line-height: 16px;
  }

  .targetArea {
    margin-right: 12px;

    & > div {
      user-select: none;
      height: 32px;
      padding: 5px 10px 5px 10px;
      white-space: nowrap;

      &.selected {
        background-color: rgba(54, 79, 199, 0.12);
        color: var(--blue-with-a-hint-of-purple);
      }
    }

    .target-item {
      margin-bottom: 1px;
      height: unset;
      padding: 12px 16px;
      border-radius: 4px;

      &:hover {
        background-color: #f7f7f8;
      }
    }
  }

  ::v-deep .simplebar-content {
    width: 100% !important;
  }

  .text-field-ellipsis {
    display: block;
    font-style: normal;
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
  }
}
</style>
